import { useMemo } from 'react';
import {
  ThreadAssistantMessagePart,
  ToolCallMessagePart,
  useAssistantState,
} from '@assistant-ui/react';

export const useToolCalls = <TResult = unknown, TArgs = unknown>(
  toolName?: string,
): ToolCallMessagePart<TArgs, TResult>[] => {
  const message = useAssistantState(state => state.message);

  return useMemo(
    () =>
      (message.content as readonly ThreadAssistantMessagePart[])
        .filter(
          part =>
            part.type === 'tool-call' &&
            (!toolName || part.toolName === toolName),
        )
        .map(part => part as unknown as ToolCallMessagePart<TArgs, TResult>),
    [message.content, toolName],
  );
};
